import { forwardRef } from "react";
import { classNames } from "zeta-dom-react";

export interface GridItemProps extends React.ComponentPropsWithRef<'div'> {
    span: '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | 'half' | 'full';
}

export const GridItem = forwardRef<HTMLDivElement, GridItemProps>((props, ref) => {
    const { span, ..._props } = props;
    return (<div {..._props} ref={ref} className={classNames('eac-grid-item', { col: span }, props.className)}></div>);
});
